import {
  Grid,
  GridCellProps,
  GridContextMenuEvent,
  GridDataStateChangeEvent,
  GridDetailRowProps,
  GridEvent,
  GridExpandChangeEvent,
  GridRowClickEvent,
  GridRowProps,
  GridSortChangeEvent,
} from "@progress/kendo-react-grid";
import { DataResult, State } from "@progress/kendo-data-query";
import sizeConfigs from "../../configs/sizeConfigs";
import { useCallback } from "react";
import React from "react";

interface CustomGridProps {
  data: any[] | DataResult | null;
  pageSize?: number;
  detail?: React.ComponentType<GridDetailRowProps> | null | undefined;
  expandChange?: ((event: GridExpandChangeEvent) => void) | undefined;
  dataStateChange?: ((event: GridDataStateChangeEvent) => void) | undefined;
  handleSort?: ((event: GridSortChangeEvent) => void) | undefined;
  scrollHandler?: ((event: GridEvent) => void) | undefined;
  onContextMenu: ((event: GridContextMenuEvent) => void) | undefined;
  handleClick: ((event: GridRowClickEvent) => void) | undefined;
  dataState: State;
  toolbar?: any;
  rows: any;
  id: string;
  isPlanoGroupe?: boolean;
}

export default function CustomGrid(props: CustomGridProps) {
  const rowRender = useCallback(
    (row: any, gridRowProps: GridRowProps) => {
      const background =
        props.isPlanoGroupe && gridRowProps.dataItem.field_highlight
          ? { style: { backgroundColor: "yellow" } }
          : {};
      const rowProps = {
        ...row.props,
        id: gridRowProps.dataItem[props.id],
        ...background,
      };
      return React.cloneElement(row, { ...rowProps }, row.props.children);
    },
    [props.id, props.isPlanoGroupe]
  );

  const cellRender = (
    tdElement: React.ReactElement<HTMLTableCellElement> | null,
    cellProps: GridCellProps
  ) => {
    if (
      cellProps.field &&
      cellProps.dataItem.field_highlight &&
      cellProps.dataItem.field_highlight
        .toUpperCase()
        .split(",")
        .includes(cellProps.field.toUpperCase())
    ) {
      return (
        <td
          aria-colindex={cellProps.columnIndex}
          role={"gridcell"}
          style={{ color: "red", backgroundColor: "yellow" }}
        >
          {cellProps.dataItem[cellProps.field!]}
        </td>
      );
    }

    return tdElement;
  };

  return (
    <Grid
      data={props.data}
      {...props.dataState}
      onRowClick={props.handleClick}
      pageSize={props.pageSize}
      onScroll={props.scrollHandler}
      onContextMenu={props.onContextMenu}
      sortable={{
        allowUnsort: true,
      }}
      onSortChange={props.handleSort}
      fixedScroll={true}
      groupable={true}
      reorderable={true}
      detail={props.detail}
      onExpandChange={props.expandChange}
      onDataStateChange={props.dataStateChange}
      expandField="expanded"
      selectedField="selected"
      resizable
      style={{
        width: "100%",
        height: `calc(100vh - ${sizeConfigs.topbar.height} - ${sizeConfigs.footer.height})`,
      }}
      id="main-grid"
      cellRender={cellRender}
      rowRender={rowRender}
    >
      {props.toolbar}
      {props.rows}
    </Grid>
  );
}
